// Shared phone number validation utilities (international, incl. Indonesia +62)
// Pattern: optional +country (1-3 digits), optional area (2-4 digits, parens ok), then 3-4 + 3-4 digit groups with separators
export const PHONE_NUMBER_REGEX = /^(\+?\d{1,3}[\s.-]?)?(\(?\d{2,4}\)?[\s.-]?)?(\d{3,4}[\s.-]?\d{3,4})$/;

export const phoneNumberRule = {
  pattern: PHONE_NUMBER_REGEX,
  message: 'Please enter a valid phone number (e.g. 5124026225, +62 812-3456-7890).',
};

export default PHONE_NUMBER_REGEX;
